import { ProductOptionName } from '../ProductOption'

interface ICustomAttribute {
  key: string
  value: string | boolean
}

export class CustomAttribute implements ICustomAttribute {
  readonly key: string
  readonly value: string

  constructor({ key, value }: ICustomAttribute) {
    this.key = key
    this.value = String(value)
    return {
      ...this,
    }
  }
}

export const CUSTOM_ATTRIBUTE_KEYS = {
  FINAL_SALE: 'final_sale',
  GOLD_BAR_PRODUCT: 'gold_bar_product',
  INSEAM: ProductOptionName.Inseam as string,
}
